const DEBUG_URL = "https://test-topik.al-electronics.uz/";
export const BASE_URL =
  process.env.VUE_APP_API_BASE
  ? process.env.VUE_APP_API_BASE : process.env.VUE_APP_TESTING
  ? "https://test-topik.al-electronics.uz/" : process.env.NODE_ENV === "production"
  ? "https://topik.al-electronics.uz/" : DEBUG_URL;
// export const BASE_URL = "http://localhost:8000/";

const API_V1 = "/api/v1";
import { i18n } from "@/i18n";

export async function getUniqueUser(cb, data, err) {
  let choices = "?";
  for (const field in data) {
    choices += `${field}=${encodeURIComponent(data[field])}&`;
  }
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${
        i18n.global.locale.value
      }${API_V1}/user-unique-check/${choices.slice(0, -1)}`
    );
    if (!res.ok) return err(res);
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

export async function getAllLabel(cb, data) {
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${i18n.global.locale.value}${API_V1}/choices/?choices=${data}`
    );
    json = await res.json();
  } catch (e) {
    return console.error("getAllLabel:", e);
  }
  cb(json);
}

//Singn-up
export async function signUp(cb, form, err) {
  let res;
  try {
    res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/register/`, {
      method: "POST",
      body: form,
    });
  } catch (e) {
    return err(e);
  }
  if (!res.ok) return err(res);
  cb(res);
}
// get-Me
export async function getMe(cb, token, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/user/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) return err(res);
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

// Auth people
export async function getTokens(cb, data, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/token/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

export async function verifyToken(cb, data, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}auth/jwt/verify/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}
export async function dropToken(cb, token, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/drop-token/`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

// Update User
export async function updateUser(cb, token, newData, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/user/`, {
      method: "PATCH",
      body: newData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

// checkIfUserIsEditable
export async function checkIfUserIsEditable(cb, token, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/user-editable-check/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}


// faq
export async function getFaq(cb) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/faq/`);
    json = await res.json();
  } catch (e) {
    return console.error("getFaq:", e);
  }
  cb(json["results"], json["count"]);
}

export async function getFaqId(cb, id) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/faq/${id}/`);
    json = await res.json();
  } catch (e) {
    return console.error("getFaqId:", e);
  }
  cb(json);
}

//  Period
export async function getLatestPeriod(cb, token, isIBT, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/latest-period/?is_ibt=${isIBT}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

export async function getRegisterPeriod(cb) {
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${i18n.global.locale.value}${API_V1}/latest-registration-period/`
    );
    json = await res.json();
  } catch (e) {
    return console.error("getRegisterPeriod:", e);
  }
  cb(json);
}

// Appeals
export async function getAppealsList(cb, token) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/user-appeals-list/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    json = await res.json();
  } catch (e) {
    return console.error("getAppealsList:", e);
  }
  cb(json["results"]);
}

export async function getAppealsDetail(cb, token, id) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/user-appeal/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    json = await res.json();
  } catch (e) {
    return console.error("getAppealsDetail:", e);
  }
  cb(json);
}

export async function getAdminAppealsDetail(cb, id, token) {
  // token = signed anketa token from the admin change-form PDF link (not a JWT)
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${i18n.global.locale.value}${API_V1}/admin-appeal/${id}?token=${encodeURIComponent(token ?? "")}`
    );
    json = await res.json();
  } catch (e) {
    return console.error("getAdminAppealsDetail:", e);
  }
  cb(json);
}

export async function getAllChoices(cb) {
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${i18n.global.locale.value}${API_V1}/choices-appeal/?choices=citizenship,nationality,region,employment,country,purpose,inform_source`
    );
    json = await res.json();
  } catch (e) {
    return console.error("getAllChoices:", e);
  }
  cb(json);
}

export async function createAppeal(cb, id, data, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/appeal/${id}/`, {
      headers: {
        Authorization: `Bearer ${data}`,
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

export async function getArticlesList(cb) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/articles/`);
    json = await res.json();
  } catch (e) {
    return console.error("getArticlesList:", e);
  }
  cb(json["results"], json["count"]);
}

export async function getArticlesListPagination(cb, limit, offset) {
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${
        i18n.global.locale.value
      }${API_V1}/articles/?limit=${limit}&offset=${limit * offset}`
    );
    json = await res.json();
  } catch (e) {
    return console.error("getArticlesListPagination:", e);
  }
  cb(json["results"], json["count"]);
}

export async function getLimiteArticlesList(cb, limit) {
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${i18n.global.locale.value}${API_V1}/articles/?limit=${limit}`
    );
    json = await res.json();
  } catch (e) {
    return console.error("getLimiteArticlesList:", e);
  }
  cb(json["results"], json["count"]);
}

export async function getArticleId(cb, id) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/article/${id}/`);
    json = await res.json();
  } catch (e) {
    return console.error("getArticleId:", e);
  }
  cb(json);
}

export async function calendar(cb, start, end) {
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${i18n.global.locale.value}${API_V1}/calendar/?start=${start}&end=${end}`
    );
    json = await res.json();
  } catch (e) {
    return console.error("calendar:", e);
  }
  cb(json);
}

export async function phoneAuth(cb, data, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/phone-auth/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

export async function sendCode(cb, data, err) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/send-code/`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.ok) return err(await res.json());
    json = await res.json();
  } catch (e) {
    return err(e);
  }
  cb(json);
}

export async function getInfoModals(cb) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/info-modals/`);
    json = await res.json();
  } catch (e) {
    return console.error("getInfoModals:", e);
  }
  cb(json);
}

export async function getLastEvents(cb, limit, offset) {
  let json;
  try {
    const res = await fetch(
      `${BASE_URL}${i18n.global.locale.value}${API_V1}/last-events/?limit=${limit}&offset=${offset}`
    );
    json = await res.json();
  } catch (e) {
    return console.error("getLastEvents:", e);
  }
  cb(json["results"]);
}

export async function getExamTypes(cb) {
  let json;
  try {
    const res = await fetch(`${BASE_URL}${i18n.global.locale.value}${API_V1}/exam-types/`);
    json = await res.json();
  } catch (e) {
    return console.error("getExamTypes:", e);
  }
  cb(json);
}
